export const featureFlags = {
  bulkMessages: 'commx-bulk-messaging',
};

export const MMS_MAX_SIZE = 1000000;
export const SENDING_STATUS_DETAILS = 'Sending...';
